import { useQuery } from "@apollo/client";
import { Card } from "@cofano/cck";
import { Box, Tab, Tabs } from "@mui/material";
import useTabs from "components/hooks/useTabs";
import { AdminLanguageTab } from "view/admin/utils/admin.types";
import AdminLanguageKeys from "./AdminLanguageKeys";
import AdminManuageLanguages from "./AdminManageLanguages";
import { GetLanguagesDocument } from "__generated__/view/admin/graphql/admin.queries.generated";

const AdminLanguage = () => {
	const { selectedTab, selectTab } = useTabs<AdminLanguageTab>({
		defaultSelected: AdminLanguageTab.LanguageKeys,
		disableParams: true,
	});

	const { data, loading, refetch } = useQuery(GetLanguagesDocument);
	const languages = data?.languages ?? [];

	return (
		<Card disablePadding>
			<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
				<Tabs
					value={selectedTab}
					indicatorColor="primary"
					scrollButtons="auto"
					onChange={(_, value) => selectTab(value)}
					variant="scrollable">

					<Tab label='Language keys' value={AdminLanguageTab.LanguageKeys} />
					<Tab label='Manage languages' value={AdminLanguageTab.ManangeLanguages} />
				</Tabs>
			</Box>

			{selectedTab === AdminLanguageTab.LanguageKeys && (
				<AdminLanguageKeys
					languages={languages} />
			)}

			{selectedTab === AdminLanguageTab.ManangeLanguages && (
				<AdminManuageLanguages
					languages={languages}
					loading={loading}
					refetch={refetch} />
			)}
		</Card>
	);
};

export default AdminLanguage;
